import { useLocation, useParams } from 'react-router-dom';
import { Button, Input, Container, Row, FormFeedback, FormGroup } from 'reactstrap';
import { Switch, Snackbar, SlideProps, Slide, Alert } from '@mui/material';
import { useRef, useState } from 'react';
import { useAppSelector } from '../../../hooks';
import Loading from '../../../Components/Loading';
import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { Nudge } from '../../../Types/Nudge';
import { analytics } from '../../../firebase';
import { logEvent } from 'firebase/analytics';
import { makeCall } from '../../../Utility/makeCallText';

type Ref = Input

interface ApiBodyRequest {
    id: string;
    message: string;
    transactionId: string;
    nudgeHelpful?: boolean;
    nudgeMessage?: string;
}

const NudgeDetail = () => {
    const { nudgeId } = useParams();
    const location = useLocation();
    const item = location.state?.item as Nudge;
    const crmNoteRef = useRef<Ref>(null);
    const helpfulNoteRef = useRef<Ref>(null);
    const [ nudgeHelpful, setNudgeHelpful ] = useState<boolean>(false);
    const [ crmNote, setCrmNote ] = useState<string>('');
    const [ crmError, setCrmError ] = useState<boolean>(false);
    const [ helpfulNoteError, setHelpfulNoteError ] = useState<boolean>(false);
    const [ helpfulNote, setHelpfulNote] = useState<string>('');
    const [ closeError, setCloseError ] = useState<any>('');
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ reqFieldToast, setReqFieldToast ] = useState<boolean>(false);
    const [ closeErrorToast, setCloseErrorToast ] = useState<boolean>(false);
    const [ successToast, setSuccessToast ] = useState<boolean>(false);
    const token = useAppSelector((state) => state.auth.token);

    const SlideTransition = (props: SlideProps) => {
        return <Slide {...props} direction="down" />
    };

    const handleClose = ( 
        event?: React.SyntheticEvent | Event, 
        reason?: string 
    ) => { 
        if (reason === 'clickaway') return; 
        setReqFieldToast(false);
        setCloseErrorToast(false);
        setSuccessToast(false);
    };

    const handleSubmit = async () => {
        if (!crmNote) {
            setReqFieldToast(true);
            setCrmError(true);
        }

        if (nudgeHelpful && !helpfulNote) {
            setHelpfulNoteError(true);
        }

        if (!nudgeHelpful && crmNote) {
            setLoading(true);
            await closeNudge();

            if (closeError) {
                setCloseErrorToast(true);
            } else {
                logEvent(analytics, 'close_nudge_web', {
                    name: 'close nudge',
                    id: item.crmTransactionId
                });
                setSuccessToast(true);
                setLoading(false);
                window.history.back();
            }

        } else if (nudgeHelpful && crmNote && helpfulNote) {
            setLoading(true);
            await closeNudge();

            if (closeError) {
                setCloseErrorToast(true);
            } else {
                logEvent(analytics, 'close_nudge_web', {
                    name: 'close nudge',
                    id: item.crmTransactionId
                });
                setSuccessToast(true);
                setLoading(false);
                window.history.back();
            }
        }
    };

    const closeNudge = async () => {
        const bodyObject: ApiBodyRequest = {
            id: item.customerId,
            message: crmNote,
            transactionId: item.crmTransactionId,
            ...(nudgeHelpful && helpfulNote.trim()
                ? {
                    nudgeHelpful: true,
                    nudgeMessage: helpfulNote.trim(),
                }
                : {}
            ),
        };

        try {
            const baseUrl = 'https://customer.hirsch.com/account/v2/employee/nudge';
            const res = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                },
                body: JSON.stringify(bodyObject),
            })

            const json = await res.json();
            console.log('Close Nudge Body:', JSON.stringify(bodyObject))
            console.log('Close Nudge Res:', json);

        } catch (err: any) {
            setCloseError(err);
            console.error('Close Nudge Error:', err.message);
        }
    }

    return (
        <>
            {loading 
                ? (<Loading />)
                : (
                    <>
                        <Snackbar
                            open={reqFieldToast}
                            onClose={handleClose}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                            slots={{
                                transition: SlideTransition
                            }}
                        >
                            <Alert
                                onClose={handleClose}
                                severity='error'
                                variant="filled"
                                sx={{ width: '100%' }}
                            >
                                Missing Required Field!
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={closeErrorToast}
                            onClose={handleClose}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                            slots={{
                                transition: SlideTransition
                            }}
                        >
                            <Alert
                                onClose={handleClose}
                                severity='error'
                                variant="filled"
                                sx={{ width: '100%' }}
                            >
                                {closeError}
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={successToast}
                            onClose={handleClose}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                            slots={{
                                transition: SlideTransition
                            }}
                        >
                            <Alert
                                onClose={handleClose}
                                severity='success'
                                variant="filled"
                                sx={{ width: '100%' }}
                            >
                                Nudge Closed for Cust ID {item.customerId}
                            </Alert>
                        </Snackbar>
                        <Container className='align-items-start text-start pt-3'>
                            <span style={{ fontWeight: 'bold', fontSize: 24 }}>Nudge CRM Update</span>
                            <div className='d-flex'>
                                <div>
                                    <span className='d-block' style={{ fontWeight: 'bold' }}>Cust ID:</span>
                                    <span className='d-block' style={{ fontWeight: 'bold' }}>Cust Name:</span>
                                    <span className='d-block' style={{ fontWeight: 'bold' }}>Writer ID:</span>
                                    <span className='d-block' style={{ fontWeight: 'bold', }}>Contact Name:</span>
                                    <span className='d-block' style={{ fontWeight: 'bold', color: 'black', }}>Phone:</span>
                                    <span className='d-block' style={{ fontWeight: 'bold', color: 'black' }}>Email:</span>
                                </div>
                                <div>
                                    <span className='d-block' style={{ paddingLeft: 5 }}>{item.customerId}</span>
                                    <span className='d-block' style={{ paddingLeft: 5 }}>{item.customerName}</span>
                                    <span className='d-block' style={{ paddingLeft: 5 }}>{item.writerId}</span>
                                    <span className='d-block' style={{ paddingLeft: 5 }}>{item.contactName}</span>
                                    <a
                                        className='d-block'
                                        style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer', paddingTop: 5 }}
                                        onClick={() => makeCall(formatPhoneLink(item.contactPhone))}
                                    >
                                        <span style={{ paddingLeft: 5, }}>{formatPhone(item.contactPhone)}</span>
                                    </a>
                                    <a 
                                        className='d-block'
                                        style={{ paddingTop: 5 }}
                                        href={`mailto:${item.contactEmail}`}
                                    >
                                        <span style={{ paddingLeft: 5, }}>{item.contactEmail}</span>
                                    </a>
                                </div>
                            </div>
                            {closeError && <span 
                                style={{ 
                                    color: 'red', 
                                    fontSize: 18,
                            }}>ERROR: {closeError}</span>}
                            <Row className='pt-3'>
                                <FormGroup>
                                    <Input
                                        ref={crmNoteRef}
                                        for='crmNote'
                                        type='textarea'
                                        placeholder='What action was taken with the customer?'
                                        bsSize='lg'
                                        multiline={true}
                                        invalid={crmError}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCrmNote(e.target.value)}
                                    />
                                    <FormFeedback invalid for='crmNote'>This is a required field</FormFeedback>
                                </FormGroup>
                            </Row>
                            <Row style={{ display: 'block', alignItems: 'center', marginTop: 20, }}>
                                <Switch 
                                    checked={nudgeHelpful}
                                    onChange={() => setNudgeHelpful(!nudgeHelpful)}
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#f1b434',
                                        },
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#f1b434',
                                        },
                                    }}
                                />
                                <span>This nudge was not helpful?</span>
                            </Row>
                            {nudgeHelpful &&
                                <>
                                    <Row className='pt-3'>
                                        <span>Why was the nudge <span style={{ textDecoration: 'underline'}}>not</span> helpful?</span>
                                    </Row>
                                    <FormGroup>
                                        <Row>
                                            <Input
                                                ref={helpfulNoteRef}
                                                type='textarea'
                                                placeholder='Please explain why...'
                                                multiline={true}
                                                bsSize='lg'
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setHelpfulNote(e.target.value)}
                                                invalid={helpfulNoteError}
                                                for='helpfulNote'
                                            />
                                            <FormFeedback invalid for='helpfulNote'>This is a required field</FormFeedback>
                                        </Row>
                                    </FormGroup>
                                </>
                            }
                            <div style={{ marginTop: 10, textAlign: 'center' }}>
                                <Button 
                                    className='mainButton'
                                    onClick={handleSubmit}
                                >
                                    <span style={{ fontWeight: 'bold'}}>Submit</span>
                                </Button>
                            </div>
                        </Container>
                    </>
                )
            }
        </>
    )
};

export default NudgeDetail;